import {
    Alert,
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Stack,
    Typography,
} from '@mui/material';
import DOMPurify from 'dompurify';
import { useHistory, useParams } from 'react-router-dom';
import { helpRoutes } from '../../routes';
import { useGetArticleById } from '../../sic-lib/api/hooks/useHelp';
import { DateTimeFormat } from '../../sic-lib/enums/DateTimeFormat';
import DisplayDateTime from '../Shared/DisplayDateTime/DisplayDateTime';
import Loader from '../Shared/Loader';

export default function HelpViewArticle() {
    const { articleId } = useParams<{ articleId: string }>();
    const history = useHistory();

    const {
        data: articleData,
        isLoading: articleLoading,
        isError: articleError,
    } = useGetArticleById(+articleId);

    const handleClick = (categoryId: number) => {
        history.push(helpRoutes.setCategory(categoryId));
    };

    if (articleLoading) {
        return <Loader isLoading={articleLoading} />;
    }

    if (!articleData) {
        return <Alert severity="info">Article not found.</Alert>;
    }

    if (articleError) {
        return <Alert severity="error">Error loading article.</Alert>;
    }

    return (
        <>
            <Card>
                <CardHeader title={articleData?.title} />
                <Divider />
                <CardContent>
                    <Stack flexDirection="column" alignItems="center" justifyContent="center">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(articleData.body),
                            }}
                        />
                        {articleData.dateUpdated && (
                            <Typography variant="caption" mt={2} alignSelf="flex-end">
                                Last updated:&nbsp;
                                {
                                    <DisplayDateTime
                                        dateText={articleData.dateUpdated}
                                        variant="caption"
                                        formatPreset={DateTimeFormat.dateTimeMed}
                                    />
                                }
                            </Typography>
                        )}
                    </Stack>
                </CardContent>
            </Card>
            <Card>
                <CardHeader title="Related Categories" />
                <Divider />
                <CardContent>
                    <Stack
                        flexDirection="column"
                        alignItems="flex-start"
                        justifyContent="flex-start"
                    >
                        {articleData.categories.map((category, index) => {
                            return (
                                <Button
                                    key={`${category.articleId}-${index}`}
                                    color="primary"
                                    onClick={() => handleClick(category.categoryId)}
                                >
                                    {category.categoryName}
                                </Button>
                            );
                        })}
                    </Stack>
                </CardContent>
            </Card>
        </>
    );
}
